module.exports = __webpack_public_path__ + "img/张锡宁副教授.71b05ea2.png";